import ArtigoPlaceholder from "@/components/feature/ArtigoPlaceholder";
export default function ArtigoAcessorios() {
  return (
    <ArtigoPlaceholder
      title="Acessórios de Moda da China: Melhores Fornecedores no CSSBuy Spreadsheet"
      desc="Relógios, óculos, joias e acessórios de moda. Guia completo com os melhores fornecedores chineses e dicas para garantir qualidade nas suas compras."
      icon="ri-glasses-line"
      slug="artigo-cssbuy-acessorios"
    />
  );
}